export default __webpack_public_path__ + "static/media/GS_Logo_M.ac947ce0.png";